import { useMemo } from "react";
import {
  useGetFacilityWholeList,
  useGetProcessTypesWholeList
} from "../../../../../api/cultivations";
import { FacilityType } from "../../../../../config/enums/FacilityType.enum";
import {
  buildFacilityOptions,
  buildNameMap,
  buildProcessTypeOptions
} from "../utils/processRecords.utils";
import { FacilityOption, ProcessRecordLookups, ProcessTypeOption } from "../types/processRecords.types";

/**
 * Fetches the static-data lists the process rows render against and derives the
 * option/name-map lookups from them. Memoized so the derived objects stay stable
 * across renders of the table.
 */
export const useProcessRecordOptions = (): ProcessRecordLookups => {
  const { data: processTypesWholeList } = useGetProcessTypesWholeList();
  const { data: facilityWholeList } = useGetFacilityWholeList(FacilityType.FACTORY);

  const processTypes = processTypesWholeList as ProcessTypeOption[] | undefined;
  const facilities = facilityWholeList as FacilityOption[] | undefined;

  return useMemo(
    () => ({
      processTypeOptions: buildProcessTypeOptions(processTypes),
      facilityOptions: buildFacilityOptions(facilities),
      facilityNameMap: buildNameMap(facilities),
      processTypeNameMap: buildNameMap(processTypes)
    }),
    [processTypes, facilities]
  );
};
